angular.module('tgaAdmin')
  .controller('ForgotController', [
    '$scope', '$state', 'userService', 'settingsService',
    function (
      $scope, $state, userService, settingsService,
    ) {
      if (userService.isLoggedIn()) {
        $state.go('v1.games');
      }

      $scope.data = {
        logo: '',
        defaultLogo: './v1/assets/images/logo-black.svg',
      };

      $scope.viewmodel = {
        email: '',
      };

      $scope.initialize = function () {
        $scope.linkSent = false;
        settingsService.getSettings().then((settings) => {
          $scope.data.logo = settings.logo || $scope.data.defaultLogo;
        });
      };

      $scope.actions = {
        return() {
          $state.go('v1.login');
        },
        submit() {
          if ($scope.forgotForm.$invalid) {
            return;
          }

          $scope.loading = true;

          userService.forgot($scope.viewmodel.email).finally(() => {
            $scope.linkSent = true;
            $scope.loading = false;
          });
        },
      };

      $scope.initialize();
    },
  ]);
